import React, { useEffect, useState } from "react";
import "./Contact_us_Form.css";
import Breadcrumb_comp from "../../common-components/breadcrumb-comp/Breadcrumb_comp";
import { Col, Form, Row } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useForm, Controller } from "react-hook-form";
import { useFullScreenHandle } from "react-full-screen";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { contactusForm } from "../../../features/contact_us/contactusSlice";
import { appSetup } from "../../../features/master/masterSlice";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import Success_Modal from "../../common-components/common_modal/success_modal/Success_Modal";

function Contact_us_Form() {
  const dispatch = useDispatch();

  const [showSuccessModal, setShowSucsessModal] = useState(false);
  const [showMap, setShowMap] = useState(false);
  const handle = useFullScreenHandle();

  const {
    control,
    reset,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const expandMap = () => {
    if (handle.active) {
      handle.exit();
    } else {
      handle.enter();
    }
  };

  const toggleMap = () => {
    if (!showMap) window.scrollTo({ top: 0, behavior: "smooth" });
    if (showMap && handle.active) {
      handle.exit();
    }
    setShowMap(!showMap);
  };

  const onSubmit = (data) => {
    dispatch(contactusForm(data));
    setShowSucsessModal(true);
    reset();
  };

 

  const breadcrumbs = [
    { label: "Home", link: "/", isActive: false },
    { label: "CONTACT US", link: "", isActive: true },
  ];

  const app_setup = useSelector((state) => state.master.app_setup);

  useEffect(() => {
    dispatch(appSetup());
  }, [dispatch]);

  const buildWhatsAppHref = (rawNumber, defaultCountryCode = "91") => {
    if (!rawNumber) return null;

    let cleaned = String(rawNumber).replace(/\D/g, "");

    cleaned = cleaned.replace(/^0+/, "");

    if (cleaned.length === 10) {
      cleaned = `${defaultCountryCode}${cleaned}`;
    }

    if (!/^\d+$/.test(cleaned)) return null;
    if (cleaned.length < 11 || cleaned.length > 15) {
      return null;
    }

    const url = `https://wa.me/${cleaned}`;

    return url;
  };

  const phoneHref = buildWhatsAppHref(app_setup?.alt_contact_no);
  return (
    <section className="Contact_us_Form">
      <div className="container">
        <Breadcrumb_comp breadcrumbs={breadcrumbs} />

        <div className="flipIn">
          <div className="container-fluid p-0">
            <div className="Form_section_holder">
              {!showMap && (
                <Row className="justify-content-center">
                  <Col xxl={12} sm={12}>
                    <div className="contact-modern-layout">
                      <Row className="g-4">
                        {/* LEFT FORM */}
                        <Col lg={8}>
                          <div className="contact-form-card">
                            <h2 className="main-title">
                              Have queries, doubts or suggestions?
                            </h2>

                            <p className="sub-title">
                              Raise an entry by filling out the form below, and
                              we'll be more than happy to help.
                            </p>

                            <hr />

                            <Form onSubmit={handleSubmit(onSubmit)}>
                              <Row>
                                <Col md={6}>
                                  <Form.Group className="mb-4">
                                    <Form.Label>Name *</Form.Label>
                                    <Form.Control
                                      type="text"
                                      placeholder="Your Name"
                                      {...register("name", {
                                        required: "Name is required",
                                      })}
                                    />
                                    {errors.name && (
                                      <p className="text-danger mt-1">{errors.name.message}</p>
                                    )}
                                  </Form.Group>
                                </Col>

                                <Col md={6}>
                                  <Form.Group className="mb-4">
                                    <Form.Label>Email *</Form.Label>
                                    <Form.Control
                                      type="email"
                                      placeholder="Your Email"
                                      {...register("email", {
                                        required: "Email is required",
                                      })}
                                    />
                                    {errors.email && (
                                      <p className="text-danger mt-1">{errors.email.message}</p>
                                    )}
                                  </Form.Group>
                                </Col>

                                <Col md={12}>
                                  <Form.Group className="mb-4">
                                    <Form.Label>Mobile Number *</Form.Label>

                                    <Controller
                                      name="number"
                                      control={control}
                                      rules={{
                                        required: "Mobile number required",
                                      }}
                                      render={({ field }) => (
                                        <PhoneInput
                                          country={"in"}
                                          value={field.value}
                                          onChange={field.onChange}
                                        />
                                      )}
                                    />
                                    {errors.number && (
                                      <p className="text-danger mt-1">{errors.number.message}</p>
                                    )}
                                  </Form.Group>
                                </Col>

                                <Col md={12}>
                                  <Form.Group className="mb-4">
                                    <Form.Label>Message *</Form.Label>

                                    <Form.Control
                                      as="textarea"
                                      rows={6}
                                      placeholder="Write your message..."
                                      {...register("message", {
                                        required: "Message is required",
                                      })}
                                    />
                                    {errors.message && (
                                      <p className="text-danger mt-1">{errors.message.message}</p>
                                    )}
                                  </Form.Group>
                                </Col>

                                <Col md={12}>
                                  <button
                                    type="submit"
                                    className="submit-btn-modern"
                                  >
                                    Submit
                                  </button>
                                </Col>
                              </Row>
                            </Form>
                          </div>
                        </Col>

                        {/* RIGHT PANEL */}

                        <Col lg={4}>
                          <div className="contact-info-card">
                            <h3 className="contact-details-heading">
                              Contact Details
                            </h3>

                            <div className="map-card">
                              <iframe
                                src={`https://maps.google.com/maps?q=${app_setup?.lat},${app_setup?.long}&z=15&output=embed`}
                                title="map"
                              />
                            </div>

                            <div className="office-block">
                              <h4>{app_setup?.company_name}</h4>

                              <p>{app_setup?.address}</p>

                              <div className="contact-item">
                                <div className="icon-circle">
                                  <FontAwesomeIcon icon={faPhone} />
                                </div>

                                <div>
                                  <span>Phone</span>
                                  <a href={`tel:${app_setup?.contact_no}`}>
                                    {app_setup?.contact_no}
                                  </a>
                                </div>
                              </div>

                              <div className="contact-item">
                                <div className="icon-circle">
                                  <FontAwesomeIcon icon={faEnvelope} />
                                </div>

                                <div>
                                  <span>Email</span>
                                  <a href={`mailto:${app_setup?.email}`}>
                                    {app_setup?.email}
                                  </a>
                                </div>
                              </div>

                              <div className="contact-item">
                                <div className="icon-circle">
                                  <FontAwesomeIcon icon={faWhatsapp} />
                                </div>

                                <div>
                                  <span>WhatsApp</span>
                                  <a href={phoneHref}>
                                    {app_setup?.alt_contact_no}
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
              )}
            </div>
          </div>
        </div>
      </div>
       <Success_Modal
        show={showSuccessModal}
        onHide={() => {
          setShowSucsessModal(false);
        }}
        successText="Enquiry Submitted !"
      />
    </section>
  );
}

export default Contact_us_Form;
